// Generated by scripts/build-ui-icons.mjs.
export { Cursor as default } from "../ui/glyphs-3";
